import React from "react";
import { Link } from "react-router-dom";
import "../styles/categories-grid.css";

import motosierraimg from "../assets/images/icons/motosierra-catalogo.jpg";
import cortadoraimg from "../assets/images/icons/cortadora-catalogo.jpg";
import cortacercoimg from "../assets/images/icons/cortacerco-catalogo.jpg";
import bordeadoraimg from "../assets/images/icons/STIHL-FSA.jpg";
import sopladorimg from "../assets/images/icons/soplador-catalogo.jpg";
import tromenimg from "../assets/images/icons/tromen-catalogo.jpg";

const CategoriesGrid = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const categories = [
    {
      id: 1,
      pill: "Corte",
      name: "Motosierras",
      description:
        "Rendimiento y precisión para enfrentar cualquier desafío de corte con eficiencia.",
      image: motosierraimg,
      link: "/productos?sub=jardin-y-poda-motosierras",
    },
    {
      id: 2,
      pill: "Jardín",
      name: "Cortadoras de césped",
      description:
        "A batería o a nafta, para un corte eficiente y uniforme en cualquier terreno.",
      image: cortadoraimg,
      link: "/productos?sub=jardin-y-poda-cortadoras-cesped",
    },
    {
      id: 3,
      pill: "Poda",
      name: "Cortacercos",
      description:
        "Dale forma precisa a tus cercos y arbustos con resultados prolijos y satisfactorios.",
      image: cortacercoimg,
      link: "/productos?sub=jardin-y-poda-cortacercos-y-podadoras-de-altura",
    },
    {
      id: 4,
      pill: "Desmalezado",
      name: "Motoguadañas y Bordeadoras",
      description:
        "Potencia y precisión para transformar tus tareas de jardinería. Lograá un corte perfecto en áreas difíciles.",
      image: bordeadoraimg,
      link: "/productos?sub=jardin-y-poda-motoguadanas-y-bordeadoras",
    },
    {
      id: 5,
      pill: "Limpieza",
      name: "Sopladores",
      description:
        "Eliminá hojas y desechos del jardín fácilmente con herramientas cómodas y eficientes.",
      image: sopladorimg,
      link: "/productos?sub=limpieza-sopladores",
    },
    {
      id: 6,
      pill: "Hogar",
      name: "Tromen",
      description:
        "Parrillas, hornos a leña, estufas y hogares de alta calidad para una experiencia única.",
      image: tromenimg,
      link: "/productos?brand=64f8f0272aecad0161443545",
    },
  ];

  return (
    <section className="categories-section">
      <div className="categories-container">
        <div className="categories-header">
          <div className="section-label">EXPLORA NUESTRAS LÍNEAS</div>
          <p className="section-subtitle">
            Encontrá la herramienta perfecta para cada necesidad
          </p>
        </div>

        <div className="categories-grid">
          {categories.map((cat, i) => (
            <Link
              key={cat.id}
              to={cat.link}
              className="category-card"
              onClick={scrollToTop}
              style={{ animationDelay: `${i * 0.07 + 0.05}s` }}
            >
              <div className="category-card-photo">
                <span className="category-card-pill">{cat.pill}</span>
                <img src={cat.image} alt={cat.name} loading="lazy" />
              </div>
              <div className="category-card-body">
                <h3 className="category-name">{cat.name}</h3>
                <p className="category-description">{cat.description}</p>
                <span className="category-link">Ver productos</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="categories-cta">
          <Link
            to="/productos"
            className="catalogue-button"
            onClick={scrollToTop}
          >
            Ver catálogo completo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CategoriesGrid;
